import { jwtDecode } from 'jwt-decode';

export const ATTENDANCE_SESSION_KEYS = [
  'level',
  'employee_id',
  'branchID',
  'headOfficeID',
  'masterID',
  'workfromhome',
  'workingHoursStart1',
  'workingHoursEnd1',
  'maxDistance1',
  'officeLon1',
  'officeLat1',
  'workingHoursStart2',
  'workingHoursEnd2',
  'maxDistance2',
  'officeLon2',
  'officeLat2',
  'workingHoursStart3',
  'workingHoursEnd3',
  'maxDistance3',
  'officeLon3',
  'officeLat3',
] as const;

export type AttendanceSessionKey = (typeof ATTENDANCE_SESSION_KEYS)[number];

type AttendanceSessionFields = Partial<Record<AttendanceSessionKey, string>>;

const setIfPresent = (
  out: AttendanceSessionFields,
  key: AttendanceSessionKey,
  value: unknown,
) => {
  if (value === undefined || value === null || value === '') return;
  out[key] = String(value);
};

export function attendanceSessionFromClaims(claims: any): AttendanceSessionFields {
  if (!claims || typeof claims !== 'object') return {};

  const out: AttendanceSessionFields = {};
  const association = claims.association || {};

  setIfPresent(out, 'level', association.level);
  setIfPresent(out, 'employee_id', claims.employee_id || claims.user_id || claims.id || claims.sub);
  setIfPresent(out, 'branchID', association.branchID || claims.branchID);
  setIfPresent(out, 'headOfficeID', association.headOfficeID || claims.headOfficeID);
  setIfPresent(out, 'masterID', association.masterID || claims.masterID);
  setIfPresent(out, 'workfromhome', claims.workfromhome);

  const offices = claims.wifi_ssid || claims.offices || {};
  for (let i = 1; i <= 3; i++) {
    const office = offices?.[i] || offices?.[String(i)];
    if (!office) continue;
    setIfPresent(out, `workingHoursStart${i}` as AttendanceSessionKey, office.working_hours_start);
    setIfPresent(out, `workingHoursEnd${i}` as AttendanceSessionKey, office.working_hours_end);
    setIfPresent(out, `maxDistance${i}` as AttendanceSessionKey, office.radius_meters);
    setIfPresent(out, `officeLon${i}` as AttendanceSessionKey, office.longitude);
    setIfPresent(out, `officeLat${i}` as AttendanceSessionKey, office.lattitude || office.latitude);
  }

  return out;
}

export function attendanceSessionFromToken(token: string | null | undefined): AttendanceSessionFields {
  if (!token) return {};
  try {
    return attendanceSessionFromClaims(jwtDecode(token));
  } catch {
    return {};
  }
}
